'use client';
import type { ReactNode } from 'react';
import { cn } from '@eliadmin/core/src/utils/style-utils';
/** Project presentation only; eligibility, selection and progress stay in the shared core. */
export function ProjectGiftSurface({
  context,
  children,
}: {
  context: 'product' | 'cart' | 'dialog';
  children: ReactNode;
}) {
  return (
    <div
      data-tenant-gifts="dzl"
      data-gift-context={context}
      className={cn(
        'min-w-0 empty:hidden',
        'text-[#0F1012] [&_img]:object-contain [&_[role=progressbar]]:h-1.5 [&_[role=progressbar]]:bg-[#F0F1F2] [&_[role=progressbar]>div]:bg-[#4DB873] [&_[data-gift-options]>button]:font-medium [&_[data-gift-options]>button]:text-[#0F1012] [&_[data-gift-tier-id]]:rounded-[12px] [&_[aria-current=true]]:border-[#0F1012] [&_[aria-current=true]]:bg-[#F5F6F7]',
        context === 'product' &&
          'rounded-[18px] border border-[#E2E4E7] bg-white p-4 [&_[data-gift-presentation=multiple]>h2]:hidden [&_[data-gift-current-preview]]:mb-2 [&_[data-gift-current-preview]_img]:h-12 [&_[data-gift-current-preview]_img]:w-12 [&_.ea-product-gift-progress>p]:text-[#6B7079]',
        context === 'cart' &&
          '[&_.ea-cart-gift-section]:rounded-[18px] [&_.ea-cart-gift-section]:border-[#E2E4E7] [&_.ea-cart-gift-section]:bg-[#F5F6F7] [&_.ea-cart-gift-section]:p-4 [&_.ea-cart-gift-section>h2]:text-[#0F1012] [&_.ea-cart-gift-section>h2_svg]:text-[#D7191F] [&_img]:rounded-[10px] [&_img]:bg-white [&_[data-gift-choice]]:rounded-[12px] [&_[data-gift-choice-indicator]]:rounded-[12px] [&_[data-gift-choice][data-selected=true]]:border-[#0F1012] [&_[data-gift-choice][data-selected=true]]:bg-[#0F1012]/10 [&_[data-gift-choice][data-selected=true]_[data-gift-choice-indicator]]:border-[#0F1012] [&_[data-gift-choice][data-selected=true]_[data-gift-choice-indicator]]:bg-[#0F1012] [&_[data-gift-choice][data-selected=true]_[data-gift-choice-indicator]]:text-white',
        context === 'dialog' &&
          '[&_.ea-cart-gift-progress_h2]:hidden [&>div]:m-0 [&>div]:max-w-none [&>div]:p-0 border-t border-[#E2E4E7] pt-4 [&_.ea-cart-gift-progress]:text-[#0F1012] [&_.ea-cart-gift-progress_h2]:text-[#0F1012] [&_.ea-cart-gift-progress_h2]:text-sm [&_.ea-cart-gift-progress_h2]:font-medium [&_img]:h-10 [&_img]:w-10 [&_img]:rounded-[10px]',
      )}
    >
      {children}
    </div>
  );
}
